// Apolo — Artifact panel store (Zustand).
//
// Holds the set of artifacts the user has opened into the side panel and which
// one is active. Surface-agnostic: both Chat and Code funnel their artifacts
// here, and a single global <ArtifactPanel/> (mounted in AppShell) renders it.
//
// Kept as its own tiny store (not a slice of the giant useAgentStore) so the
// artifact seam stays isolated and easy to reason about / test.

import { create } from 'zustand';

export const useArtifactStore = create((set, get) => ({
  open: false,
  items: [], // artifact descriptors from detectArtifact(), newest last
  activeId: null,

  // Open (or re-focus) an artifact in the panel. Dedupes by id so re-rendering
  // the same message doesn't stack duplicates; a re-open just focuses it.
  openArtifact(artifact) {
    if (!artifact || !artifact.id) return;
    set((state) => {
      const exists = state.items.some((a) => a.id === artifact.id);
      const items = exists
        ? state.items.map((a) => (a.id === artifact.id ? artifact : a))
        : [...state.items, artifact];
      return { items, activeId: artifact.id, open: true };
    });
  },

  focus(id) {
    if (!get().items.some((a) => a.id === id)) return;
    set({ activeId: id, open: true });
  },

  // Close a single tab. If it was active, fall back to the last remaining one;
  // if none remain, close the panel.
  closeArtifact(id) {
    set((state) => {
      const items = state.items.filter((a) => a.id !== id);
      if (items.length === 0) return { items, activeId: null, open: false };
      const activeId = state.activeId === id ? items[items.length - 1].id : state.activeId;
      return { items, activeId };
    });
  },

  close() {
    set({ open: false });
  },

  reset() {
    set({ open: false, items: [], activeId: null });
  },
}));
